/** @format */

import { observable, action } from 'mobx';
import ResourceStore from './classes/ResourceStore';
import database from '../firebase/config';
import { getTimestamp } from '../helpers/getTimestamp';

class WarehousesStore extends ResourceStore {
  @observable ref = `warehouses`;
  @observable tableKeys = [
    { label: 'SEDE', prop: 'name' },
    { label: 'PERCORSO RICHIESTE', prop: 'priority' },
  ];
  @observable defaultItem = { uid: null, name: '', priority: {} };
  @observable edit = {
    errors: false,
    currentItem: { uid: null, name: '' },
    priorityWarehouses: [{ uid: null }],
  };
  @observable search = {
    value: '',
    attributes: ['name'],
  };

  @action createWarehouse = () => {};

  @action getNextWarehouse = (sellerLocation, currentWarehouse) => {
    // Debug logs
    if (!this.items[sellerLocation]) {
      console.error(`Seller location '${sellerLocation}' not found`);
      console.error(JSON.stringify(this.items));
    }

    let nextWarehouse = false;
    let sellerLocationPriority = this.items[sellerLocation].priority;
    let currentWarehousePriority =
      this.items[sellerLocation].priority[currentWarehouse];

    Object.keys(sellerLocationPriority).forEach(location => {
      if (sellerLocationPriority[location] === currentWarehousePriority + 1) {
        nextWarehouse = location;
      }
    });

    return nextWarehouse;
  };

  @action getFirstWarehouse = sellerLocation => {
    let firstWarehouse = false;
    const sellerLocationPriority =
      this.items[sellerLocation] && this.items[sellerLocation].priority;
    if (sellerLocationPriority) {
      Object.keys(sellerLocationPriority).forEach(location => {
        if (sellerLocationPriority[location] === 1) {
          firstWarehouse = location;
        }
      });
    }
    return firstWarehouse;
  };

  @action resetCurrentItem = () => {
    this.edit.errors = false;
    this.edit.currentItem = this.defaultItem;
    this.edit.priorityWarehouses = [];
  };

  @action loadCurrentItem = uid => {
    this.edit.currentItem = this.items[uid];
    if (this.edit.currentItem.priority) {
      this.edit.priorityWarehouses = Object.keys(
        this.edit.currentItem.priority,
      ).map(key => ({
        uid: key,
        name: this.items[key] ? this.items[key].name : '',
      }));
    }
  };

  @action handlePriorityChange = (uid, index) => {
    this.edit.priorityWarehouses[index] = {
      uid: uid,
      name: this.items[uid].name,
    };
  };

  @action addPriority = () => {
    if (this.edit.priorityWarehouses.length < this.getItems.length) {
      this.edit.priorityWarehouses.push(this.defaultItem);
    }
  };

  @action removePriority = index => {
    this.edit.priorityWarehouses = this.edit.priorityWarehouses.filter(
      (item, key) => key !== index,
    );
  };

  @action submit = () => {
    let currentItem = this.edit.currentItem;
    currentItem.uid = this.edit.currentItem.uid
      ? this.edit.currentItem.uid
      : '';
    currentItem.timestamp = getTimestamp();

    const method = currentItem.uid !== '' ? 'set' : 'push';
    const userRef = database.ref(`${this.ref}/${currentItem.uid}`);
    currentItem.priority = {};
    this.edit.priorityWarehouses.forEach((priority, index) => {
      currentItem.priority[priority.uid] = index + 1;
    });

    userRef[method](currentItem)
      .then(item => {
        if (item && method === 'push') {
          currentItem.uid = item.key;
        }
        // Carico in lista la versione aggiornata dell'item (se update) oppure il nuovo item (se create)
        this.items[currentItem.uid] = currentItem;

        this.toggleEditModal();
        this.resetCurrentItem();
      })
      .catch(() => {
        this.edit.errors = true;
      });
  };
}

export default new WarehousesStore();
